<template>
  <li
    class="kd-sidebar-icon"
    :class="[ classWithLabel ]"
    @click="runAction"
  >
    <div
      class="kd-sidebar-icon__bg-circle"
      v-tooltip.left="{
        content: tooltipText,
        show: TOOLTIPS_VISIBLE,
        trigger: 'manual',
      }"
      :disabled="false"
    >
      <img class="kd-sidebar-icon__icon" :src="icon">
    </div>
    <div class="kd-sidebar-icon__label">{{ label }}</div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  TOOLTIPS_VISIBLE,
} from '@/store/getter-types';

export default {
  props: {
    label: String,
    icon: String,
    action: String,
    tooltipText: String,
  },
  computed: {
    ...mapGetters([
      TOOLTIPS_VISIBLE,
    ]),
    /**
     * Returns e.g. "kd-sidebar-icon--tipps", based on label "Tipps"
     */
    classWithLabel() {
      if (!this.label) { return ''; }
      const labelSave = this.label
        .toLowerCase()
        .replace(/ /g, '-'); // get rid of spaces.
      return `kd-sidebar-icon--${labelSave}`;
    },
  },
  methods: {
    /*
     * Dispatches an action, e.g. "TOGGLE_TOOLTIPS", or "SHOW_PREVIEW"
     */
    runAction() {
      if (this.action) {
        this.$store.dispatch(this.action);
      }
    },
  },
};
</script>

<style lang="scss">
  .kd-sidebar-icon {
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
      opacity: 0.8;
    }

    & + & {
      margin-top: 22px;
    }
  }

  .kd-sidebar-icon__bg-circle {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 50%;
    margin-bottom: 14px;

    @media all and (max-width: 1200px) {
      width: 30px;
      height: 30px;
    }
  }

  .kd-sidebar-icon__icon {
    width: 24px;
  }

  .kd-sidebar-icon__label {
    font-size: 13px;
    font-weight: 600;
  }
</style>
